<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="标签名称">
          <el-input
            style="width: 220px"
            v-model.trim="queryForm.categoryName"
            clearable
            placeholder="请输入标签名称"
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="openForm('add')"
          >新增</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        stripe
        size="small"
        :data="listData"
        row-key="categoryId"
        default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column
          prop="categoryName"
          label="标签名称"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="categoryDescription"
          label="标签描述"
          min-width="220"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="sort"
          label="排序"
          width="90"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row.categoryParentId"
              plain
              round
              size="small"
              type="success"
              @click="
                openForm('add', { categoryParentId: scope.row.categoryId })
              "
              >新增子类</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="primary"
              @click="openForm('edit', scope.row)"
              >编辑</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="danger"
              @click="deleteInfo(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <CourseCategoryForm ref="formRef" @success="search" />
  </div>
</template>

<script>
import {
  getOneLevelCategories,
  getTwoLevelCategories,
  deleteCourseCategory
} from "@/api/content/courseCategory";
import CourseCategoryForm from "./CourseCategoryForm.vue";

export default {
  name: "CourseCategory",
  components: { CourseCategoryForm },
  data() {
    return {
      queryForm: {
        categoryName: ""
      },
      listData: [],
      parentOptions: [],
      loading: false
    };
  },
  created() {
    this.search();
  },
  methods: {
    resetSelect() {
      this.queryForm = { categoryName: "" };
      this.search();
    },
    normalizeList(result) {
      const data = result && result.data;
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.rows)) return data.rows;
      return [];
    },
    async search() {
      this.loading = true;
      try {
        const params = {};
        if (this.queryForm.categoryName) {
          params.categoryName = this.queryForm.categoryName;
        }
        const [oneRes, twoRes] = await Promise.all([
          getOneLevelCategories(params),
          getTwoLevelCategories(params)
        ]);
        const oneList = this.normalizeList(oneRes);
        const twoList = this.normalizeList(twoRes);
        this.parentOptions = oneList.map(item => ({
          categoryId: item.categoryId,
          categoryName: item.categoryName
        }));
        const childrenMap = {};
        twoList.forEach(item => {
          const pid = item.categoryParentId;
          if (!childrenMap[pid]) childrenMap[pid] = [];
          childrenMap[pid].push(item);
        });
        this.listData = oneList.map(item => ({
          ...item,
          categoryParentId: item.categoryParentId || 0,
          children: childrenMap[item.categoryId] || []
        }));
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    openForm(type, row) {
      this.$refs.formRef.open(type, row || {}, this.parentOptions);
    },
    deleteInfo(row) {
      const hasChildren =
        Array.isArray(row.children) && row.children.length > 0;
      const tip = hasChildren
        ? "该标签下存在子标签，确定仍要删除吗？"
        : "确定要删除该标签吗？";
      this.$confirm(tip, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            await deleteCourseCategory(row.categoryId);
            this.$message.success("删除成功");
            this.search();
          } catch (e) {}
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/CourseCategory/index.vue